import { createClient } from "contentful";

export async function fetchProductTags(slug) {
  const client = createClient({
    // This is the space ID. A space is like a project folder in Contentful terms
    space: "vqzddtz845zg",
    // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
    accessToken: "kZzHneMOPyOpm7N22fWCu8zQnWMXqsJZXM35c2KFpXI",
  });
  try {
    const response = await client.getEntries({
      content_type: "product",
      "fields.slug": slug,

      limit: 1,
    });

    const collections = await client.getEntries({
      content_type: "collections",
      links_to_entry: response.items[0].sys.id,
    });

    if (collections.items && collections.items.length > 0) {
      return collections.items;
    }
    console.log("No entry found.");
  } catch (error) {
    console.log("Error occurred while fetching entry:", error);
  }
}

export async function fetchProductOverview(slug) {
  const client = createClient({
    // This is the space ID. A space is like a project folder in Contentful terms
    space: "vqzddtz845zg",
    // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
    accessToken: "kZzHneMOPyOpm7N22fWCu8zQnWMXqsJZXM35c2KFpXI",
  });
  try {
    const response = await client.getEntries({
      content_type: "product",
      "fields.slug": slug,

      limit: 1,
    });

    return response?.items?.[0]?.fields?.overview;
  } catch (error) {
    console.log("Error occurred while fetching entry:", error);
  }
}
